import { Box, Typography, Link } from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Formik } from 'formik';
import * as utils from "../../../utils/pluginStoreUtils"
import {ProofOfPurchaseForm} from './ProofOfPurchaseForm';
import { ensureOrderOfFlowLambdas, getReformatedАutoRedeemCnAndRsConfig, isReceiptScannerWithAutoRedeemCnG } from '../../AssignPromotion/AssignPromotionPage';
import { ProofOfPurchaseValidationSchema } from './ProofOfPurchaseValidationSchema';
import { notificationType } from '../../../types/notifications';
import './../MixCodes/MixCodes.css';
import '../CommonStyles.css';
import { saveConfig } from '../../../utils/s3FileUtils';
import { mixCodes } from '../../../constants/helpful-link';
import GenericSpinner from '../../../common/Spinners/GenericSpinner';
import { ConfigType } from '../../../types/configuration';

interface props {
    config: { [key: string]: any };
    setNotificationState: Dispatch<SetStateAction<notificationType>>;
    handleTabChange: Dispatch<SetStateAction<boolean>>;
    setConfig: Dispatch<SetStateAction<ConfigType>>;
    promoFlow?: string;
}

export type Prize = {
    id: string;
    name: string;
    [key: string]: any;
};

export type PrizeMappingViral = {
    viralCode: string;
    prizes: Prize[];
};

export type PrizeMappingPin = {
    pincodes: string;
    prizes: Prize[];
};

const mixcodesInitialValues = (config, promoFlow) => {
        const configFlow = config.flow?.[promoFlow] ?? {};
        const configParams = configFlow.params ?? {};
        let backendMapping: PrizeMapping[] = [];

        if (configParams.winningPrizesPerViralCode) {
            backendMapping = Object.entries(
                configParams.winningPrizesPerViralCode
            ).map(([viralCode, prizes]) => ({
                viralCode,
                prizes: Array.isArray(prizes) ? prizes : [],
            }));
        }
        else if (configParams.winningPrizesPerPinCodes) {
            const programEntries = Object.entries(configParams.winningPrizesPerPinCodes || {});
            const firstProgramEntry = programEntries[0];

            backendMapping = firstProgramEntry
                ? Object.entries(firstProgramEntry[1]).map(([lotId, prizes]) => ({
                    pincodes: lotId,
                    prizes: Array.isArray(prizes) ? prizes : [],
                    }))
                : [];
        }
        const mixCodesEnabled = backendMapping.length > 0;

        let updatedState = {
            ...config,
            tempParams: {
                codeType:
                    (config.flow[promoFlow]?.secrets?.mixCodesParameters &&
                        config.flow[promoFlow].secrets?.mixCodesParameters.map((obj: any) => {
                            if (obj.uri.includes('pincodes')) {
                                return 'Pincodes';
                            }
                            return 'Viral Codes';
                        })) ||
                    [],
                pincodeOriginValitidy: !!(
                    config.flow[promoFlow]?.checkerLambdas &&
                    config.flow[promoFlow].checkerLambdas.includes('pincodeOriginValidityCheckerLambda')
                ),
                mixCodesPrizeMapping: mixCodesEnabled,
            },
            params: {
                lotIds: config.flow[promoFlow]?.params?.lotIds || [''],
                campaignIds: config.flow[promoFlow]?.params?.campaignIds || [''],
                mixCodesPrizeMapping: { mapping: backendMapping },
            },
            secrets: {
                ...(config.flow[promoFlow]?.secrets?.mixCodesParameters
                    ? { mixCodesParameters: [...config.flow[promoFlow]?.secrets?.mixCodesParameters] }
                    : { mixCodesParameters: [{ programId: '', secret: '', uri: '' }] }),
            },
            checkerLambdas: config.flow[promoFlow]?.checkerLambdas || [],
            flowLambdas: (config.flow[promoFlow]?.flowLambdas.length ? ['burnPincodes', ...config.flow[promoFlow]?.flowLambdas] : ['burnPincodes']),
        };
        return updatedState;
};

const initialProofType = (config, promoFlow) => {
    if (utils.isRsPresentInConfig(config, promoFlow)) {
        return 'receiptScanner';
    }
    if(config.flow?.[promoFlow]?.flowLambdas?.includes('burnPincodes')) {
        return 'mixCodes';
    }
    return 'none';
}

const rsInitialValues = (config, promoFlow) => { // this is only used in the edit
        const rsPresentInConfig = utils.isRsPresentInConfig(config, promoFlow);
        const { uploadImage, pluginParams, pluginRoutes } = utils.generateRsConfigParams(config?.configurationParameters?.country);
        const vals = {
            ...config,
            flow: {
                ...config.flow,
                [promoFlow]: {
                    ...config.flow[promoFlow],
                    ...(!rsPresentInConfig && { pluginRoutes } )
                },
                ...(!rsPresentInConfig && { uploadImage }),
            },
            pluginParams: {
                ...(!rsPresentInConfig ? pluginParams : config.pluginParams)
            },
            tempParams: { rsPresentInConfig, promoFlow }
        }
        return vals;
    }

export type PrizeMapping = PrizeMappingViral | PrizeMappingPin;

const clearRSSubmissionValues = (values, promoFlow) => {
    let valuesClearedFromRS = { ...values };
    delete valuesClearedFromRS.flow.uploadImage
    delete valuesClearedFromRS.pluginParams
    delete valuesClearedFromRS.flow[promoFlow].pluginRoutes
    delete valuesClearedFromRS.proofType
    return valuesClearedFromRS;
}

const cleanMixCodesSubmissionValues = (values, promoFlow) => {
let valuesClearedFromMixCodes = { ...values };
delete valuesClearedFromMixCodes.flow?.[promoFlow]?.params?.lotIds;
delete valuesClearedFromMixCodes.flow?.[promoFlow]?.params?.campaignIds;
delete valuesClearedFromMixCodes.flow?.[promoFlow]?.secrets?.mixCodesParameters;
delete valuesClearedFromMixCodes.tempParams?.codeType;
delete valuesClearedFromMixCodes.flow?.[promoFlow]?.params?.winningPrizesPerPinCodes;
delete valuesClearedFromMixCodes.flow?.[promoFlow]?.params?.winningPrizesPerViralCode;
delete valuesClearedFromMixCodes.tempParams?.mixCodesPrizeMapping;

if (valuesClearedFromMixCodes.flow?.[promoFlow]?.checkerLambdas) {
    valuesClearedFromMixCodes.flow[promoFlow].checkerLambdas = valuesClearedFromMixCodes.flow?.[promoFlow]?.checkerLambdas.filter(checker => checker !== 'pincodeOriginValidityCheckerLambda');
    !valuesClearedFromMixCodes.flow?.[promoFlow].checkerLambdas.length && delete valuesClearedFromMixCodes.flow?.[promoFlow].checkerLambdas;
}


valuesClearedFromMixCodes.flow[promoFlow].flowLambdas = valuesClearedFromMixCodes.flow?.[promoFlow].flowLambdas.filter(flowLambda => flowLambda !== 'burnPincodes')
delete valuesClearedFromMixCodes.flowLambdas
delete valuesClearedFromMixCodes.checkerLambdas
delete valuesClearedFromMixCodes.secrets
delete valuesClearedFromMixCodes.params
delete valuesClearedFromMixCodes.tempParams
delete valuesClearedFromMixCodes.proofType
if (promoFlow === 'redeemPincodeForCurrencies' || promoFlow === 'autoRedeemCnG') {
    valuesClearedFromMixCodes.pluginParams.pluginResponseOnly = true;
}
return valuesClearedFromMixCodes;
}


const cleanPincodeValidatorDetails = (params) => {
        for (const key of ['lotIds', 'campaignIds']) {
            if (params[key]?.length === 1 && params[key][0] === '') delete params[key];
        }
    }

const mixCodesSubmissionValues = (values, inputPromoFlow) => {
        let { checkerLambdas, flowLambdas, params, secrets, tempParams, ...rest } = clearRSSubmissionValues(values, inputPromoFlow);

        if (!tempParams.pincodeOriginValitidy || tempParams.pincodeOriginValitidy === '' ) {
            checkerLambdas = checkerLambdas.filter((lambda: string) => lambda !==  'pincodeOriginValidityCheckerLambda')
            rest.flow[inputPromoFlow].checkerLambdas = values.flow[inputPromoFlow]?.checkerLambdas?.filter((lambda: string) => lambda !==  'pincodeOriginValidityCheckerLambda')
            if (!(checkerLambdas.length > 0)) {
            delete rest.flow[inputPromoFlow].checkerLambdas
            }
            delete values.flow[inputPromoFlow]?.params?.lotIds;
            delete values.flow[inputPromoFlow]?.params?.campaignIds;
            delete values.flow[inputPromoFlow]?.params?.mixCodesPrizeMapping;
        }

        if(inputPromoFlow === 'autoRedeemCnG'){
            flowLambdas.unshift('pincodeToCurrency');
        }

        cleanPincodeValidatorDetails(params);

        if(!tempParams.mixCodesPrizeMapping) {
            delete values.flow[inputPromoFlow]?.params?.winningPrizesPerViralCode;
            delete values.flow[inputPromoFlow]?.params?.winningPrizesPerPinCodes;
        }
        let winningPrizesPerPinCodes: Record<string, Record<string, string[]>> = {};
        let winningPrizesPerViralCode: Record<string, string[]> = {};

        if (tempParams.mixCodesPrizeMapping || tempParams.winningPrizesPerPinCodes) {
            if (params.mixCodesPrizeMapping?.mapping?.length) {
            params.mixCodesPrizeMapping.mapping.forEach((row: any) => {
                // For PinCodes
                if (row.pincodes && tempParams.codeType.includes("Pincodes") && params.campaignIds === undefined) {
                    const lotId = row.pincodes;
                    const prizes = row.prizes || [];

                    if (Array.isArray(secrets.mixCodesParameters)) {
                        secrets.mixCodesParameters.forEach((param: any) => {
                            const programId = param?.programId;
                            if (!programId) return;

                            if (!winningPrizesPerPinCodes[programId]) {
                                winningPrizesPerPinCodes[programId] = {};
                            }

                            if (!winningPrizesPerPinCodes[programId][lotId]) {
                                winningPrizesPerPinCodes[programId][lotId] = [];
                            }

                            winningPrizesPerPinCodes[programId][lotId] =
                                winningPrizesPerPinCodes[programId][lotId].concat(prizes);
                            });
                    }
                }

                // For Viral Codes
                if (row.viralCode && params.campaignIds && params.campaignIds.length > 0 && tempParams.codeType.includes('Viral Codes')) {
                if (!winningPrizesPerViralCode[row.viralCode]) winningPrizesPerViralCode[row.viralCode] = [];
                winningPrizesPerViralCode[row.viralCode] = winningPrizesPerViralCode[row.viralCode].concat(row.prizes || []);
                }
            });
            }
        }
        // Determine if only viral codes are being saved (no pincodes)
        const isOnlyViralCodes =
            tempParams.mixCodesPrizeMapping &&
            (!params.lotIds || params.lotIds.length === 0 || (params.lotIds.length === 1 && params.lotIds[0] === '')) &&
            params.campaignIds &&
            params.campaignIds.length > 0 ;

        let updatedValues = {
            ...rest,
            flow: {
                ...rest.flow,
                [inputPromoFlow]: {
                    ...rest.flow[inputPromoFlow],
                    ...(secrets && ({ secrets: { ...secrets } })),
                    flowLambdas: ensureOrderOfFlowLambdas(flowLambdas),
                    ...(checkerLambdas.length > 0 && { checkerLambdas }),
                    params: {
                        ...rest.flow[inputPromoFlow]?.params,
                        ...(params.lotIds && params.lotIds.length > 0 && {lotIds: [...params.lotIds]}),
                        ...(params.campaignIds && params.campaignIds.length > 0 && {campaignIds: [...params.campaignIds]}),
                        ...(isOnlyViralCodes
                    ? (Object.keys(winningPrizesPerViralCode).length > 0
                    ? { winningPrizesPerViralCode }
                    : {})
                    : {
                    ...(tempParams.mixCodesPrizeMapping && Object.keys(winningPrizesPerViralCode).length > 0
                        ? { winningPrizesPerViralCode }
                        : {}),
                    ...(tempParams.mixCodesPrizeMapping && Object.keys(winningPrizesPerPinCodes).length > 0 && {
                        winningPrizesPerPinCodes: winningPrizesPerPinCodes
                    }),
                    }),
                },
            },
            },
        };

        if(updatedValues.flow[inputPromoFlow].params && Object.keys(updatedValues.flow[inputPromoFlow].params).length === 0) {
            delete updatedValues.flow[inputPromoFlow].params;
        };
        return updatedValues;
}

const rsSubmissionValues = (values, inputPromoFlow) => {
    const mixCodesSubmissionValue = cleanMixCodesSubmissionValues(values, inputPromoFlow);
    if (isReceiptScannerWithAutoRedeemCnG(inputPromoFlow, values)) {
        return getReformatedАutoRedeemCnAndRsConfig(mixCodesSubmissionValue, ['pincodeToCurrency', 'transactionLambda']);
    }
    return mixCodesSubmissionValue;
}

const noPoPSubmissionValues = (values, inputPromoFlow) =>
    cleanMixCodesSubmissionValues(
        clearRSSubmissionValues(values, inputPromoFlow),
        inputPromoFlow
    );


const submissionHandler =  {
    mixCodes: mixCodesSubmissionValues,
    receiptScanner: rsSubmissionValues,
    none: noPoPSubmissionValues
}

const initialValues = (config, promoFlow) => {
    const mixcodes = mixcodesInitialValues(config, promoFlow);
    const rs = rsInitialValues(config, promoFlow);

    return {
        ...mixcodes,
        ...rs,
        tempParams: {
            ...(mixcodes.tempParams || {}),
            ...(rs.tempParams || {}),
        },
        proofType: initialProofType(config, promoFlow),
    };
};



const ProofOfPurchase = ({ config, setNotificationState, handleTabChange, setConfig, promoFlow }: props) => {
    const [initialValuesState, setInitialValuesState] = useState(initialValues(config, promoFlow));
    const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
    let urlParams = useParams();

    useEffect(() => {
        setInitialValuesState(initialValues(config, promoFlow));
    }, [config, promoFlow]);


    return (
        <>
        <GenericSpinner showSpinner={showLoadingSpinner} />
        <Box className='mixcodes-main-box'>
            <Formik
                initialValues={{ ...initialValuesState}}
                enableReinitialize
                validationSchema={ProofOfPurchaseValidationSchema(promoFlow)}
                onSubmit={async (values) => {
                    const updatedConfig = submissionHandler[values.proofType](values, promoFlow);
                    try {
                        setShowLoadingSpinner(true);
                        await saveConfig({ urlParams, submitData: updatedConfig, setNotificationState });
                        setNotificationState({
                            open: true,
                            title: 'Promotion updated successfully',
                            content: 'Promotion Changes were saved!',
                            level: 'success',
                        });
                        setShowLoadingSpinner(false);
                    } catch (e) {
                        console.error(e);
                    } finally {
                        setConfig(updatedConfig)
                    }
                }}>
                <Form>
                    <ProofOfPurchaseForm handleTabChange={handleTabChange} />
                </Form>
            </Formik>

            <Typography variant='h3' sx={{ marginTop: 'calc(100vh - 700px)' }} className='links-title'>
                Helpful Links
            </Typography>
            <Box className='helpfulLinks'>
                    <Link target='_blank' href={mixCodes.MIX_CODE_INTEGRATION} rel='noopener noreferrer'>
                        MiX Codes NGPS Integration
                    </Link>
            </Box>
        </Box>
    </>
    );
};

export { ProofOfPurchase };
